import { render, staticRenderFns } from "./ratemanagetable.vue?vue&type=template&id=482cfa75&scoped=true&"
import script from "./ratemanagetable.vue?vue&type=script&lang=js&"
export * from "./ratemanagetable.vue?vue&type=script&lang=js&"
import style0 from "./ratemanagetable.vue?vue&type=style&index=0&id=482cfa75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cfa75",
  null
  
)

export default component.exports